//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { agreementListApi, agreementInfoApi, agreementUpdateApi } from '@/api/setting';
import ueditorFrom from '@/components/form-common/oa-wangeditor';
export default {
  name: 'agreement',
  components: {
    ueditorFrom: ueditorFrom
  },
  data: function data() {
    return {
      treeData: null,
      defaultProps: {
        children: 'children',
        label: 'title',
        value: 'id'
      },
      height: 'calc(100vh - 200px)',
      activeValue: '',
      // 记录当前那个框展开
      currentNodeKey: 0,
      content: '',
      contents: '',
      id: null,
      loadding: false,
      currentData: {}
    };
  },
  mounted: function mounted() {
    this.getRoleCreate();
  },
  methods: {
    getRoleCreate: function getRoleCreate() {
      var _this = this;
      agreementListApi().then(function (res) {
        _this.treeData = res.data.list;
        var nVal = _this.treeData[0].id;
        _this.$nextTick(function () {
          _this.$refs.tree.setCurrentKey(nVal);
        });
        _this.getDocEdit(nVal);
      });
    },
    // tree节点点击
    handleClick: function handleClick(node, data) {
      this.$refs.ueditorFrom.clear();
      this.isShowEdit = '';
      this.getDocEdit(node.id);
    },
    ueditorEdit: function ueditorEdit(e) {
      this.content = e;
    },
    getDocEdit: function getDocEdit(id) {
      var _this2 = this;
      agreementInfoApi(id).then(function (res) {
        var data = res.data;
        _this2.currentData = data;
        _this2.$nextTick(function () {
          setTimeout(function () {
            _this2.content = data.content;
          }, 100);
        });
        _this2.id = data.id;
      });
    },
    // 保存当前
    saveCurrent: function saveCurrent() {
      var _this3 = this;
      this.content = this.$refs.ueditorFrom.getValue();
      if (!this.content) {
        this.$message.error('内容为空');
      } else {
        this.loadding = true;
        var content = this.content;
        agreementUpdateApi(this.id, {
          content: content
        }).then(function (res) {
          _this3.loadding = false;
        }).catch(function (error) {
          _this3.loadding = false;
        });
      }
    }
  }
};